import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../styles/Achievements.css'



export const Achievements = () => {
  
    return (
      <div style={{ backgroundColor: '#1a1a1a', padding: '50px 0', color: '#fff' }}>
      

      <div className="w-full relative mt-5 mb-5">
      <Swiper
        className="centered-slide-carousel"
        centeredSlides={true}
        loop={true}
        spaceBetween={100}
        autoplay={{
          delay: 3000, 
          disableOnInteraction: false, 
        }}
        pagination={{
          el: '.swiper-pagination',
          clickable: true,
        }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        breakpoints={{
          1920: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1028: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          990: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
        modules={[Pagination, Navigation, Autoplay]} 
      >
        <SwiperSlide>
          <div className="rounded-2xl h-150 w-350 justify-center items-center">
          <h1 style={{ textAlign: 'center', fontFamily: 'Cantata One, serif', marginBottom: '20px' }}>
            Variety Magazine
          </h1>
          <p style={{ textAlign: 'center', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
            "Turner is Coldwell Banker's No. 1 agent worldwide, and her expertise has propelled her to the top of luxury real estate agents in the country."
          </p>
          <div className='hover-image-wrapper'>
          <img
            className="d-block w-100 mt-5 hover-image"
            src="/assets/images/img1.jpg" 
            alt="Agent Profile"
            style={{height:'500px', borderRadius:'20px'}}
          />
          </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=" rounded-2xl h-150  justify-center items-center">
          <h1 style={{ textAlign: 'center', fontFamily: 'Cantata One, serif', marginBottom: '20px' }}>
            Mansion Magazine
          </h1>
          <p style={{ textAlign: 'center', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
            "Turner is Coldwell Banker's No. 1 agent worldwide, and her expertise has propelled her to the top of luxury real estate agents in the country."
          </p>
          <div className='hover-image-wrapper'>
          <img
            className="d-block w-100 mt-5  hover-image"
            src="/assets/images/img2.jpg" 
            alt="Agent Profile"
            style={{height:'500px', borderRadius:'20px'}}
          />
          </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=" rounded-2xl h-150  justify-center items-center">
          <h1 style={{ textAlign: 'center', fontFamily: 'Cantata One, serif', marginBottom: '20px' }}>
            Embed Magazine
          </h1>
          <p style={{ textAlign: 'center', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
            "Turner is Coldwell Banker's No. 1 agent worldwide, and her expertise has propelled her to the top of luxury real estate agents in the country."
          </p>
          <div className='hover-image-wrapper'>
          <img
            className="d-block w-100 mt-5 hover-image"
            src="/assets/images/img3.jpg" 
            alt="Agent Profile"
            style={{height:'500px', borderRadius:'20px'}}
          />
          </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=" rounded-2xl h-150  justify-center items-center">
          <h1 style={{ textAlign: 'center', fontFamily: 'Cantata One, serif', marginBottom: '20px' }}>
            Hollywood Magazine
          </h1>
          <p style={{ textAlign: 'center', fontSize: '18px', maxWidth: '600px', margin: '0 auto' }}>
            "Turner is Coldwell Banker's No. 1 agent worldwide, and her expertise has propelled her to the top of luxury real estate agents in the country."
          </p>
          <div className='hover-image-wrapper'>
          <img
            className="d-block w-100 mt-5 hover-image"
            src="/assets/images/img4.jpg" 
            alt="Agent Profile"
            style={{height:'500px', borderRadius:'20px'}}
          />
          </div>
          </div>
        </SwiperSlide>

        {/* Next and Previous Buttons */}
        <div className="swiper-button-prev slider-arrow">
          
        </div>
        <div className="swiper-button-next slider-arrow">
          
        </div>

        {/* Pagination */}
        <div className="swiper-pagination"></div>
      </Swiper>
    </div>

      <div className="sliding-cards-container mt-5 mb-5">
        <div className="sliding-cards">
          {/* Original Cards */}
          <div className="card"><img src="/assets/images/logo.svg" alt="logo1" /></div>
          <div className="card"><img src="/assets/images/logo2.svg" alt="logo2" /></div>
          <div className="card"><img src="/assets/images/logo3.svg" alt="logo3" /></div>
          <div className="card"><img src="/assets/images/logo4.svg" alt="logo4" /></div>
          
          {/* Duplicated Cards */}
          <div className="card"><img src="/assets/images/logo.svg" alt="logo1" /></div>
          <div className="card"><img src="/assets/images/logo2.svg" alt="logo2" /></div>
          <div className="card"><img src="/assets/images/logo3.svg" alt="logo3" /></div>
          <div className="card"><img src="/assets/images/logo4.svg" alt="logo4" /></div>
        </div>
      </div>
    </div>
  )
}
